import React from "react";
import { TableRow, TableCell } from "@mui/material";
import MDTypography from "components/MDTypography";
import { styled } from "@mui/material/styles";
import colors from "assets/theme-dark/base/colors";

interface EmptyTableBodyProps {
  colSpan: number;
}

/**
 * Renders an empty state for the driver metrics table when no data is available.
 * @param props - Component props including colSpan for the table.
 * @returns JSX.Element - The rendered empty table body.
 */
const EmptyTableBody: React.FC<EmptyTableBodyProps> = ({ colSpan }) => {
  return (
    <TableRow>
      <RegularTableCell colSpan={colSpan} align="center">
        <MDTypography variant="body2" color="text.secondary">
          Calculate data to view results
        </MDTypography>
      </RegularTableCell>
    </TableRow>
  );
};

const RegularTableCell = styled(TableCell)({
  border: `1px solid ${colors.grey[300]}`,
  padding: "12px",
  fontSize: "0.75rem",
  color: colors.text.primary,
  backgroundColor: colors.background.default,
  whiteSpace: "nowrap",
});

export default EmptyTableBody;
